/* tslint:disable */
/* eslint-disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MyOrdersQueryVariables = {
    activeFulfillers?: number | null;
    fulfillerIndex?: number | null;
};
export type MyOrdersQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"MyOrderList_query" | "DeviceMonitor_query" | "FinalizeDialog_query">;
};
export type MyOrdersQuery = {
    readonly response: MyOrdersQueryResponse;
    readonly variables: MyOrdersQueryVariables;
};



/*
query MyOrdersQuery(
  $activeFulfillers: Int
  $fulfillerIndex: Int
) {
  ...MyOrderList_query_3l69tB
}

fragment MyOrderList_query_3l69tB on Query {
  myOrders(activeFulfillers: $activeFulfillers, fulfillerIndex: $fulfillerIndex) {
    ...OrderDetails_order
    id
    name
    status
    reservedBy
    reservedAt
    paidAt
    cardVideoURL
    cardVideoSHA256
    cardVideoEncodeProgress
    shareVideoEncodeProgress
    shareVideoURL
    customerName
    scheduledDeliveryDate
    loyaltyCode
    notes {
      id
      createdAt
      content
      createdBy {
        name
        email
      }
    }
    balanceUsages {
      id
      vendorSaleVendorId
      vendorSaleId
    }
    vendorSale {
      id
      vendorId
    }
    customer {
      id
      email
      flagOrders {
        createdByName
        createdByEmail
        createdAt
        description
        emoji
      }
    }
    shopify {
      email
      createdAt
      note
      giftMessage
      discountCodes
      shippingAddress {
        address1
        address2
        city
        company
        countryCode
        name
        phone
        province
        provinceCode
        zip
      }
      shipping {
        carrierIdentifier
        code
      }
      lineItems {
        quantity
        SKU
        product {
          title
          images {
            src
          }
        }
        destination {
          id
          coversPrinted
          cover {
            approvedAt
            id
          }
          backCover {
            approvedAt
            id
          }
        }
      }
    }
    shippingLabels {
      label_id
      is_return
      created_at
      status
      voided
      shipment_id
      tracking_number
      carrier_code
      service_code
      label_download {
        pdf
        png
      }
      form_download {
        href
      }
    }
    cardVideoEncodedConfig {
      vertical
      allowVertical
    }
  }
}

fragment OrderDetails_order on Order {
  id
  name
  status
  createdAt
  reservedBy
  reservedAt
  paidAt
  cardVideoURL
  cardVideoSHA256
  cardVideoEncodeAttempts
  cardVideoEncodeProgress
  shareVideoEncodeProgress
  shareVideoURL
  customerName
  loyaltyCode
  notes {
    id
    createdAt
    content
    createdBy {
      name
      email
    }
  }
  balanceUsages {
    id
    vendorSaleVendorId
    vendorSaleId
    products {
      productId
      quantity
    }
  }
  vendorSale {
    id
    vendorId
  }
  designs {
    design {
      id
      generation
      createdAt
      isBlank
      durationSeconds
      media {
        id
        type
        format
        encodedLocation
        thumbnailLocation
        encodeProgress
        encodeAttempts
        isVertical
      }
      renders {
        id
        formFactor
        task
        signedURL
        sizeKB
        encodedConfig {
          vertical
        }
      }
    }
    destinations {
      id
      createdAt
      state
      bookType
      coverId
      quantity
      shippingSpeed
      shippingServiceCode
      giftMessage {
        body
      }
      address {
        fullName
        companyName
        street1
        street2
        cityLocality
        countryCode
        stateProvinceCode
        postalCode
        phoneNumber
      }
      extras {
        id
      }
      items {
        id
        createdAt
        type
        state
      }
      packages {
        id
        createdAt
        state
        shippingLabels {
          label_id
          is_return
          status
          created_at
          tracking_number
          service_code
          voided
        }
      }
    }
  }
  customer {
    id
    email
    flagOrders {
      createdByName
      createdByEmail
      createdAt
      description
      emoji
    }
  }
  shopify {
    email
    createdAt
    note
    giftMessage
    discountCodes
    videoManifest
    shippingAddress {
      address1
      address2
      city
      company
      countryCode
      name
      firstName
      phone
      province
      provinceCode
      zip
    }
    shipping {
      carrierIdentifier
      code
    }
    lineItems {
      quantity
      SKU
      product {
        title
        images {
          src
        }
      }
      destination {
        id
        coversPrinted
        cover {
          approvedAt
          id
        }
        backCover {
          approvedAt
          id
        }
      }
    }
  }
  shippingLabels {
    label_id
    created_at
    status
    voided
    shipment_id
    tracking_number
    tracking_status
    label_download {
      pdf
      png
    }
    form_download {
      href
    }
  }
  cardVideoEncodedConfig {
    vertical
    allowVertical
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "activeFulfillers"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fulfillerIndex"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "activeFulfillers",
    "variableName": "activeFulfillers"
  },
  {
    "kind": "Variable",
    "name": "fulfillerIndex",
    "variableName": "fulfillerIndex"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label_id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_return",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tracking_number",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "service_code",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voided",
  "storageKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "approvedAt",
    "storageKey": null
  },
  (v2/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoTransferStatus",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoPercentageTransferred",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MyOrdersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "MyOrderList_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DeviceMonitor_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FinalizeDialog_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MyOrdersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "myOrders",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reservedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reservedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paidAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardVideoURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardVideoSHA256",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardVideoEncodeAttempts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardVideoEncodeProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shareVideoEncodeProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shareVideoURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "loyaltyCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderNote",
            "kind": "LinkedField",
            "name": "notes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BalanceUsage",
            "kind": "LinkedField",
            "name": "balanceUsages",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vendorSaleVendorId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vendorSaleId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BalanceUsageProduct",
                "kind": "LinkedField",
                "name": "products",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productId",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VendorSale",
            "kind": "LinkedField",
            "name": "vendorSale",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vendorId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DesignWithDestinations",
            "kind": "LinkedField",
            "name": "designs",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Design",
                "kind": "LinkedField",
                "name": "design",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "generation",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isBlank",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "durationSeconds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEntry",
                    "kind": "LinkedField",
                    "name": "media",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "format",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "encodedLocation",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbnailLocation",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "encodeProgress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "encodeAttempts",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isVertical",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Render",
                    "kind": "LinkedField",
                    "name": "renders",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formFactor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "task",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "signedURL",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sizeKB",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoConfiguration",
                        "kind": "LinkedField",
                        "name": "encodedConfig",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Destination",
                "kind": "LinkedField",
                "name": "destinations",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bookType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coverId",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shippingSpeed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shippingServiceCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "giftMessage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "companyName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "street1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "street2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cityLocality",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stateProvinceCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postalCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Extra",
                    "kind": "LinkedField",
                    "name": "extras",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PackageItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Package",
                    "kind": "LinkedField",
                    "name": "packages",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShippingLabel",
                        "kind": "LinkedField",
                        "name": "shippingLabels",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v4/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Customer",
            "kind": "LinkedField",
            "name": "customer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FlagInfo",
                "kind": "LinkedField",
                "name": "flagOrders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdByName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdByEmail",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emoji",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShopifyOrder",
            "kind": "LinkedField",
            "name": "shopify",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "note",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "giftMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discountCodes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoManifest",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ShopifyAddress",
                "kind": "LinkedField",
                "name": "shippingAddress",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address1",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address2",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "company",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "province",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "provinceCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "zip",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ShopifyShipping",
                "kind": "LinkedField",
                "name": "shipping",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "carrierIdentifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ShopifyLineItem",
                "kind": "LinkedField",
                "name": "lineItems",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "SKU",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShopifyProduct",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShopifyImage",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "src",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Destination",
                    "kind": "LinkedField",
                    "name": "destination",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "coversPrinted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Cover",
                        "kind": "LinkedField",
                        "name": "cover",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Cover",
                        "kind": "LinkedField",
                        "name": "backCover",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShippingLabel",
            "kind": "LinkedField",
            "name": "shippingLabels",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v14/*: any*/),
              (v4/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shipment_id",
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tracking_status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LabelDownload",
                "kind": "LinkedField",
                "name": "label_download",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pdf",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "png",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormDownload",
                "kind": "LinkedField",
                "name": "form_download",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "href",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "carrier_code",
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VideoConfiguration",
            "kind": "LinkedField",
            "name": "cardVideoEncodedConfig",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowVertical",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledDeliveryDate",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoDownloadStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoPercentageDownloaded",
                "storageKey": null
              },
              (v19/*: any*/),
              (v20/*: any*/)
            ]
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FinalizeDialogState",
            "kind": "LinkedField",
            "name": "finalizeDialogState",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOpen",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showWrongVideoMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showLabelSection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showVideoSection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowAutoPrint",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowAutoBuy",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "devices",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "beca1e0435977d475e14b3925597683e",
    "id": null,
    "metadata": {},
    "name": "MyOrdersQuery",
    "operationKind": "query",
    "text": "query MyOrdersQuery(\n  $activeFulfillers: Int\n  $fulfillerIndex: Int\n) {\n  ...MyOrderList_query_3l69tB\n}\n\nfragment MyOrderList_query_3l69tB on Query {\n  myOrders(activeFulfillers: $activeFulfillers, fulfillerIndex: $fulfillerIndex) {\n    ...OrderDetails_order\n    id\n    name\n    status\n    reservedBy\n    reservedAt\n    paidAt\n    cardVideoURL\n    cardVideoSHA256\n    cardVideoEncodeProgress\n    shareVideoEncodeProgress\n    shareVideoURL\n    customerName\n    scheduledDeliveryDate\n    loyaltyCode\n    notes {\n      id\n      createdAt\n      content\n      createdBy {\n        name\n        email\n      }\n    }\n    balanceUsages {\n      id\n      vendorSaleVendorId\n      vendorSaleId\n    }\n    vendorSale {\n      id\n      vendorId\n    }\n    customer {\n      id\n      email\n      flagOrders {\n        createdByName\n        createdByEmail\n        createdAt\n        description\n        emoji\n      }\n    }\n    shopify {\n      email\n      createdAt\n      note\n      giftMessage\n      discountCodes\n      shippingAddress {\n        address1\n        address2\n        city\n        company\n        countryCode\n        name\n        phone\n        province\n        provinceCode\n        zip\n      }\n      shipping {\n        carrierIdentifier\n        code\n      }\n      lineItems {\n        quantity\n        SKU\n        product {\n          title\n          images {\n            src\n          }\n        }\n        destination {\n          id\n          coversPrinted\n          cover {\n            approvedAt\n            id\n          }\n          backCover {\n            approvedAt\n            id\n          }\n        }\n      }\n    }\n    shippingLabels {\n      label_id\n      is_return\n      created_at\n      status\n      voided\n      shipment_id\n      tracking_number\n      carrier_code\n      service_code\n      label_download {\n        pdf\n        png\n      }\n      form_download {\n        href\n      }\n    }\n    cardVideoEncodedConfig {\n      vertical\n      allowVertical\n    }\n  }\n}\n\nfragment OrderDetails_order on Order {\n  id\n  name\n  status\n  createdAt\n  reservedBy\n  reservedAt\n  paidAt\n  cardVideoURL\n  cardVideoSHA256\n  cardVideoEncodeAttempts\n  cardVideoEncodeProgress\n  shareVideoEncodeProgress\n  shareVideoURL\n  customerName\n  loyaltyCode\n  notes {\n    id\n    createdAt\n    content\n    createdBy {\n      name\n      email\n    }\n  }\n  balanceUsages {\n    id\n    vendorSaleVendorId\n    vendorSaleId\n    products {\n      productId\n      quantity\n    }\n  }\n  vendorSale {\n    id\n    vendorId\n  }\n  designs {\n    design {\n      id\n      generation\n      createdAt\n      isBlank\n      durationSeconds\n      media {\n        id\n        type\n        format\n        encodedLocation\n        thumbnailLocation\n        encodeProgress\n        encodeAttempts\n        isVertical\n      }\n      renders {\n        id\n        formFactor\n        task\n        signedURL\n        sizeKB\n        encodedConfig {\n          vertical\n        }\n      }\n    }\n    destinations {\n      id\n      createdAt\n      state\n      bookType\n      coverId\n      quantity\n      shippingSpeed\n      shippingServiceCode\n      giftMessage {\n        body\n      }\n      address {\n        fullName\n        companyName\n        street1\n        street2\n        cityLocality\n        countryCode\n        stateProvinceCode\n        postalCode\n        phoneNumber\n      }\n      extras {\n        id\n      }\n      items {\n        id\n        createdAt\n        type\n        state\n      }\n      packages {\n        id\n        createdAt\n        state\n        shippingLabels {\n          label_id\n          is_return\n          status\n          created_at\n          tracking_number\n          service_code\n          voided\n        }\n      }\n    }\n  }\n  customer {\n    id\n    email\n    flagOrders {\n      createdByName\n      createdByEmail\n      createdAt\n      description\n      emoji\n    }\n  }\n  shopify {\n    email\n    createdAt\n    note\n    giftMessage\n    discountCodes\n    videoManifest\n    shippingAddress {\n      address1\n      address2\n      city\n      company\n      countryCode\n      name\n      firstName\n      phone\n      province\n      provinceCode\n      zip\n    }\n    shipping {\n      carrierIdentifier\n      code\n    }\n    lineItems {\n      quantity\n      SKU\n      product {\n        title\n        images {\n          src\n        }\n      }\n      destination {\n        id\n        coversPrinted\n        cover {\n          approvedAt\n          id\n        }\n        backCover {\n          approvedAt\n          id\n        }\n      }\n    }\n  }\n  shippingLabels {\n    label_id\n    created_at\n    status\n    voided\n    shipment_id\n    tracking_number\n    tracking_status\n    label_download {\n      pdf\n      png\n    }\n    form_download {\n      href\n    }\n  }\n  cardVideoEncodedConfig {\n    vertical\n    allowVertical\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bdabdd1eec52e4abeab399e821550300';
export default node;
